import React, { useRef, useState, useEffect, useContext } from 'react';
import AuthContext from './../context/AuthProvider';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { Titulo, Formulario, FormularioGrid, Label, InputRadio, Wrapper, Item, RadioButton, RadioButtonLabel, InputCheck, ContenedorTerminos, ContenedorBotonCentrado, BotonAmarillo, BotonGris, MensajeExito, MensajeError, MensajeDocumentos } from '../elementos/FormFicha';
import { BotonAmarilloModal, BotonGrisModal, TextoRojoModal } from '../elementos/FormModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationTriangle, faSmileWink } from '@fortawesome/free-solid-svg-icons';
import ComponenteInput from './Input';
import ComponenteSelectSexo from './SelectSexo';
import ComponenteSelectRelacion from './SelectRelacion';
import SelectDocumento from './SelectDocumento';
import SelectHorario from './SelectHorario';
import SelectUbicacion from './SelectUbicacion';
import { Header, LogoOscuro } from '../elementos/Headers';
import { Footer } from '../elementos/Footers';
import Card from 'react-bootstrap/Card';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import Registro from './Registro';
import Documentos from './Documentos';
import '../estilos.css';
import ProgressIntoDialog from '../componentes/Progress/Progress';
import SimpleReactValidator from 'simple-react-validator';
import { Navigate } from 'react-router-dom';
import VentanaModalion from './VentanaModal';
import { ContenedorCentrado, TextoAmarillo, TextoNegro} from '../elementos/FormRegistro';
import UploaderDocument from './UploaderDocument';
import MensajeValidacion from './MensajeValidacion';
import Check from 'react-bootstrap/FormCheck';
import { useSearchParams } from "react-router-dom";

const baseUrlCRM = process.env.REACT_APP_URL_API_CRM;
const baseUrlGDO = process.env.REACT_APP_URL_API_GDO;
const FICHA_URL = '/fichas_matricula';
const apiKeyGDO = process.env.REACT_APP_APIKEY_GDO;
const apiKeyCRM = process.env.REACT_APP_APIKEY_CRM;
const urlAPIVulnerabilidad = process.env.REACT_APP_API_VULNERABILIDAD;
const FichaMatricula = ({ guid_oportunidad, usuarios, version_crm }) => {

  const [searchParams, setSearchParams] = useSearchParams();

  guid_oportunidad = searchParams.get("guid"); 
  usuarios = searchParams.get("usuarioAdministrativo");//6a1d2667-1929-ec11-b6e6-0022483751cf
  version_crm = searchParams.get("crm");    

  const errRef = useRef();  
  const [loading, setLoading] = useState(false);
  const [edadActual, setedadActual] = useState(0);
  const [valorTipoFicha, setvalorTipoFicha] = useState(0);
  /* Datos Personales */ 
  const [PostobtenerFichaMatricula,setPostobtenerFichaMatricula]=useState([]);
  const [departamento, setDep] = useState({ guid: '', nombre: '' });
  const [provincia, setProv] = useState({ guid: '', nombre: '' });
  const [distrito, setDist] = useState({ guid: '', nombre: '' });
  const [direccion, setDireccionNew] = useState('');
  const [ApellidoPaterno,setApellidoPaterno] = useState('');
  const [ApellidoMaterno,setApellidoMaterno] = useState('');
  const [Nombres,setNombres] = useState(''); 
  const [NumeroDocumento,setNumeroDocumento]= useState('');
  const [FechaNacimiento,setFechaNacimiento]=useState('');
  const [telefonoFijo, setTelefonoFijoNew] = useState('');
  const [celular, setCelularNew] = useState('');
  const [correoElectronico, setCorreoElectronicoNew] = useState('');  
  const [Documento, setDocumento] = useState({ codigo: '', nombre: '', numero: '' });
  /* Datos Apoderado*/
  const [Relacion, setRelacion] = useState({ id: '', nombre: '' });
  const [Ocupacion, setOcupacion] = useState('')
  const [NombresApoderado, setNombresApoderado] = useState('')
  const [ApellidoPaternoApoderado, setApellidoPaternoApoderado] = useState('');  
  const [ApellidoMaternoApoderado, setApellidoMaternoApoderado] = useState('')
  const [DireccionApoderado, setDireccionApoderado] = useState('')
  const [celularApoderado, setcelularApoderado] = useState('')
  const [mailApoderado, setmailApoderado] = useState('')
  const [NumeroDocumentoApoderado, setNumeroDocumentoApoderado] = useState('')
  const [DepApoderado, setDepApoderado] = useState({ guid: '', nombre: '' });
  const [ProvApoderado, setProvApoderado] = useState({ guid: '', nombre: '' });
  const [DistApoderado, setDistApoderado] = useState({ guid: '', nombre: '' });
  const [DocumentoApoderado, setDocumentoApoderado] = useState({ codigo: '', nombre: '', numero: '' });
  const [TelefonoCasaApoderado, setTelefonoCasaApoderado] = useState('')
  const [Horarios,setHorarios]=useState({codigo:'',nombreHorario:''});
  /* Datos Declaraciónes */
  const [datosDeclaracion, setPostDeclaracion] = useState([]);
  const [PostObtenerRegistroId,setPostObtenerRegistroId]=useState('')
  /* Datos Información Laboral*/
  const [tipoTrabajo, setTipoTrabajoNew] = useState('1');
  const [razonSocialTrab, setRazonSocialTrabNew] = useState('');  
  const [rucTrab, setRucTrabNew] = useState('');
  const [departamentoTrab, setDepartamentoTrabNew] = useState({ guid: '', nombre: '' });
  const [provinciaTrab, setProvinciaTrabNew] = useState({ guid: '', nombre: '' });
  const [distritoTrab, setDistritoTrabNew] = useState({ guid: '', nombre: '' });
  const [telefonoTrab, setTelefonoTrabNew] = useState('');
  const [anexoTrab, setAnexoTrabNew] = useState('');
  const [aceptoTyCNew, setAceptoTyCNew] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [successRegistro, setSuccessRegistro] = useState(true);
  const [showModal, setShow] = useState(false);
  const [showModalAprobar, setShowAprobar] = useState(false);
  const [showModalResincronizar, setshowModalResincronizar] = useState(false);
  const [refresh , setRefresh] = useState(false);
  const [errorStatus,seterrorStatus]= useState(false);
  const [Sexo, setSexo] = useState({ id: '', nombre: '' });
  const [activarBoton, setactivarBoton] = useState('');
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCloseAprobar = () => setShowAprobar(false);
  const handleShowAprobar = () => setShowAprobar(true);
  const handleCloseResincronizar = () => setshowModalResincronizar(false);
  const handleShowResincronizar = () => setshowModalResincronizar(true);
  const [esobligatorioVal, setesobligatorioVal] = useState(true);  
  const [NavegacionRetroceder, setNavegacionRetroceder] = useState(false);
  const [vistaCargaDocumento , setvistaCargaDocumento ]=useState({ id: '', nombre: '' ,url: '' ,visible:false});
  const [CargaMatrizDocumento,setCargaMatrizDocumento]=useState(true);
  const [GuidSubModalidad,setGuidSubModalidad]=useState();
  const [cargaExitosaSubModalidad,setcargaExitosaSubModalidad] =useState(true);
  const [PeriodoBanner,setPeriodoBanner] = useState('');
  const [datapdf,setdatapdf]=useState('');
  const [anularficha,setanularficha]=useState('');
  const [NavegacionRetrocederlogin,setNavegacionRetrocederlogin]=useState(false);
  const [actualizarficha,setactualizarficha]=useState('');
  const [Aprobarfichas,setAprobarfichas]=useState('');
  const [ResincronizarData,setResincronizarData]=useState('');
  const [CargaExitosa,setCargaExitosa]=useState(false);
  const [dataCrm, setdataCrm] = useState([]);
  const [respuestasCuestionario, setRespuestasCuestionario] = useState('');
  
  var ImgRegistro = require('./../wwwroot/images/img-upn2.png');
 
  const handleDeclaracion = (event) => {
    const value = event.target.value;
    let checked=event.target.checked;
    checked = (checked == true ? checked : '');    
    setPostDeclaracion(
      datosDeclaracion.map(item =>
        item.id == value
          ? { ...item, isChecked: checked }
          : item));
  }
 
  SimpleReactValidator.addLocale('es', {
    accepted: ':attribute debe ser aceptado.',
    after: ':attribute debe ser una fecha posterior a :date.',
    after_or_equal: ':attribute debe ser una fecha posterior o igual a :date.',
    alpha: ':attribute sólo debe contener letras.',
    array: ':attribute debe ser un conjunto.',
    before: ':attribute debe ser una fecha anterior a :date.',
    before_or_equal: ':attribute debe ser una fecha anterior o igual a :date.',
    between: ':attribute tiene que estar entre :min - :max:type.',
    boolean: 'El campo :attribute debe tener un valor verdadero o falso.',
    date: ':attribute no es una fecha válida.',
    date_equals: ':attribute debe ser una fecha igual a :date.',
    email: ':attribute no es un correo válido',
    in: ':attribute es inválido :values.',
    integer: ':attribute debe ser un número entero.',
    max: 'El :attribute no debe ser mayor a :max carácteres.',
    min: 'El :attribute debe ser de al menos :min carácteres.',
    not_in: ':attribute es inválido :values.',
    not_regex: 'El formato del campo :attribute no es válido.',
    numeric: 'El :attribute debe ser numérico.',
    regex: 'El formato de :attribute es inválido.',
    required: 'El campo :attribute es obligatorio.',
    size: 'El tamaño de :attribute debe ser :size:type.',
    string: 'El campo :attribute debe ser una cadena de caracteres.',
    url: 'El formato :attribute es inválido.',
  });

  const [, forceUpdate] = useState();
  const validator = useRef(new SimpleReactValidator({ locale: 'es', autoForceUpdate: { forceUpdate: forceUpdate } }))
 
     function getEdad(dateString) {
          let hoy = new Date()
          let fechaNacimiento = new Date(dateString)
          let edad = hoy.getFullYear() - fechaNacimiento.getFullYear()
          let diferenciaMeses = hoy.getMonth() - fechaNacimiento.getMonth()
          if (diferenciaMeses < 0 || (diferenciaMeses === 0 && hoy.getDate() < fechaNacimiento.getDate())) {
            edad--
          }
          return edad
     }
   
     function obtenerFichaMatricula(guid){     
     setLoading(true);
     var auth = {
      headers: { 'Content-Type': 'application/json', 'Authorization': apiKeyGDO, "version-crm": version_crm }
     };
     axios.get(baseUrlGDO + 'api/oportunidades/' + guid + '/fichas_matricula', auth)
      .then(async response => {
        var docs = response.data.obj;        
        if(docs!=null){
           setCargaExitosa(true);
        }
        setedadActual(getEdad(moment(docs.fechaNacimiento.split(" ")[0], "DD/MM/YYYY").format("YYYY-MM-DD")));  
        setvalorTipoFicha(docs.objTipoFichaMatricula.id);
        setPostobtenerFichaMatricula(docs);
                
        validator.current.purgeFields();
        setLoading(false);

        const resp = await obtenerRespuestasCuestionario(response.data.jwt)
        if (resp.status == 'OK') {
          setRespuestasCuestionario(resp.details.respuestas)
        }
        else{
          console.log(resp)
        }
        return response.data;
      })
      .catch(err => {
          setSuccessRegistro(false)  
          if (err.response) {

            setErrMsg(err.response.data.message);           

            if(err.response.status==404 || err.response.status=='404'){
              seterrorStatus(true)
              setErrMsg('No existe la ficha de postulación');
            }
          } else if (err.request) {
            setErrMsg('Ha ocurrido un error al registrar la ficha de postulación. Porfavor intente nuevamente');
          } else {
            setErrMsg('Ha ocurrido un error al registrar la ficha de postulación. Porfavor intente nuevamente');
          }
      });
     }

     function obtenerRespuestasCuestionario(jwtUsuario){
      return fetch(`${urlAPIVulnerabilidad}/cuestionario-prospecto/respuestas/${guid_oportunidad}`,{
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${jwtUsuario}`,
        }
        
      }).then(async resp => {
        return await resp.json()
      })
      .catch(err => {
        console.log(err)
      });
     }


     function obtenerRegistroFichaMatricula(guid) {    
      setLoading(true);
      var auth = {
        headers: { 'Content-Type': 'application/json', 'Authorization': apiKeyCRM, "version-crm": version_crm }
      };
      axios.get(baseUrlCRM + 'api/oportunidades/' + guid, auth)
        .then(response => {
          var docs = response.data
  

          if(docs.guid_submodalidad_ingreso==null || docs.guid_submodalidad_ingreso==undefined)
          {
            setcargaExitosaSubModalidad(false)
          }
             
          // Se determina el tipo de ficha y el titulo dependiendo de la version del CRM
           
          setdataCrm(docs) 
          setLoading(false);
          return response.data;
        })
        .catch(err => {
        });
    }
   
    const handleSubmit = (e) => {
        e.preventDefault();            
        setactivarBoton(false);
        handleShow();       
    }

    const handleSubmitAprobar=(e)=>{
      e.preventDefault();    
      setactivarBoton(false);
      handleShowAprobar();   
    }


    const handleSubmitResincronizar=(e)=>{
      e.preventDefault();   
      setactivarBoton(false);
      handleShowResincronizar();    
    }
 

    async function ActualizarFicha() {           
      if (validator.current.allValid()) {       
      setLoading(true);
      var tipo_ficha = PostobtenerFichaMatricula.objTipoFichaMatricula.id;   
          const response = await axios.put(baseUrlGDO + 'api/oportunidades/' + guid_oportunidad + '/fichas_matricula/'+ PostobtenerFichaMatricula.idFichaMatricula,
            JSON.stringify({            
              "GuidOportunidad": PostobtenerFichaMatricula.guidOportunidad,
              "IdTipoFichaMatricula": tipo_ficha,
              "ApellidoPaterno": ApellidoPaterno,
              "ApellidoMaterno": ApellidoMaterno,
              "Nombres": Nombres,
              "CodigoTipoDocumento":Documento.codigo,
              "TipoDocumento": Documento.nombre,
              "NumeroDocumento": NumeroDocumento,
              "CodigoSexo": Sexo.id,
              "Sexo": PostobtenerFichaMatricula.sexo,
              "FechaNacimiento":FechaNacimiento,
              "Apoderado": null,
              "Adjuntos": null,
              "Usuario": usuarios,
              "Inscripcion": valorTipoFicha== 1? {} : {
                 "GuidHorario":Horarios.codigo,
                 "Horario":  PostobtenerFichaMatricula.inscripcion.horario ,
                 "NivelEstudios": 0,
                 "GuidInstitucionEducativa": PostobtenerFichaMatricula.inscripcion.guidInstitucionEducativa ,
                 "InstitucionEducativa": PostobtenerFichaMatricula.inscripcion.institucionEducativa ,
                 "CentroEstudios": PostobtenerFichaMatricula.inscripcion.centroEstudios ,
                 "GuidDepartamentoInstitucion": PostobtenerFichaMatricula.inscripcion.guidDepartamentoInstitucion ,
                 "DepartamentoInstitucion": PostobtenerFichaMatricula.inscripcion.departamentoInstitucion ,
                 "GuidProvinciaInstitucion": PostobtenerFichaMatricula.inscripcion.guidProvinciaInstitucion ,
                 "ProvinciaInstitucion": PostobtenerFichaMatricula.inscripcion.provinciaInstitucion ,
                 "GuidDistritoInstitucion": PostobtenerFichaMatricula.inscripcion.guidDistritoInstitucion ,
                 "DistritoInstitucion": PostobtenerFichaMatricula.inscripcion.distritoInstitucion
              }
            }), 
            {
              headers: { 'Content-Type': 'application/json', 'Authorization': apiKeyGDO, "version-crm": version_crm },
              withCredentials: true
            }
          ).catch (function(err) 
          {
              setSuccessRegistro(false)  
              if (err.response) {
              
                setErrMsg(err.response.data.message);
              } else if (err.request) {
                
                setErrMsg('Ha ocurrido un error al registrar la ficha de postulación. Porfavor intente nuevamente');
              } else {
                 
                setErrMsg('Ha ocurrido un error al registrar la ficha de postulación. Porfavor intente nuevamente');
              }
           });        
        
        setactualizarficha(response.data);
        setSuccessRegistro(true);
        setLoading(false);
        } else {
        validator.current.showMessages();
        forceUpdate(1)       
      }  
    }

    
  async function AnularFicha() { 
    setLoading(true); 
    var tipo_ficha = PostobtenerFichaMatricula.objTipoFichaMatricula.id;  
    
        var auth = {
            headers: { 'Content-Type': 'application/json', 'Authorization': apiKeyGDO, "version-crm": version_crm }
          };
          const response = await axios.delete(baseUrlGDO + 'api/oportunidades/' + guid_oportunidad + '/fichas_matricula/'+ PostobtenerFichaMatricula.idFichaMatricula,auth,
          JSON.stringify({            
             "guidOportunidad": PostobtenerFichaMatricula.guidOportunidad,
             "idTipoFichaMatricula": tipo_ficha,
             "apellidoPaterno": PostobtenerFichaMatricula.apellidoPaterno,
             "apellidoMaterno": PostobtenerFichaMatricula.apellidoMaterno,
             "nombres": PostobtenerFichaMatricula.nombres,
             "codigoTipoDocumento":PostobtenerFichaMatricula.codigoTipoDocumento,
             "tipoDocumento": PostobtenerFichaMatricula.tipoDocumento,
             "numeroDocumento": PostobtenerFichaMatricula.numeroDocumento,
             "codigoSexo": PostobtenerFichaMatricula.codigoSexo,
             "sexo": PostobtenerFichaMatricula.sexo,
             "fechaNacimiento": PostobtenerFichaMatricula.fechaNacimiento,
             "apoderado": null,
             "adjuntos": null,
             "inscripcion": {
                "GuidHorario": PostobtenerFichaMatricula.inscripcion.guidHorario,
                "Horario":  PostobtenerFichaMatricula.inscripcion.horario ,
                "NivelEstudios": 0,
                "GuidInstitucionEducativa": PostobtenerFichaMatricula.inscripcion.guidInstitucionEducativa ,
                "InstitucionEducativa": PostobtenerFichaMatricula.inscripcion.institucionEducativa ,
                "CentroEstudios": PostobtenerFichaMatricula.inscripcion.centroEstudios ,
                "GuidDepartamentoInstitucion": PostobtenerFichaMatricula.inscripcion.guidDepartamentoInstitucion ,
                "DepartamentoInstitucion": PostobtenerFichaMatricula.inscripcion.departamentoInstitucion ,
                "GuidProvinciaInstitucion": PostobtenerFichaMatricula.inscripcion.guidProvinciaInstitucion ,
                "ProvinciaInstitucion": PostobtenerFichaMatricula.inscripcion.provinciaInstitucion ,
                "GuidDistritoInstitucion": PostobtenerFichaMatricula.inscripcion.guidDistritoInstitucion ,
                "DistritoInstitucion": PostobtenerFichaMatricula.inscripcion.distritoInstitucion
             }
          })          
        ).catch (function(err) 
        {
        setSuccessRegistro(false)  
        if (err.response) {
        
          setErrMsg(err.response.data.message);
        } else if (err.request) {
       
          setErrMsg('Ha ocurrido un error al registrar la ficha de postulación. Porfavor intente nuevamente');
        } else {
         
          setErrMsg('Ha ocurrido un error al registrar la ficha de postulación. Porfavor intente nuevamente');
        }
         });         
        setanularficha(response.data);
        setSuccessRegistro(true);
        setLoading(false);
  }
 
  async function AprobarFicha(){  
    setLoading(true);
      
        const response = await axios.post(baseUrlGDO + 'api/oportunidades/' + guid_oportunidad + '/fichas_matricula/'+ PostobtenerFichaMatricula.idFichaMatricula + '/aprobar' ,
          JSON.stringify({            
            "Usuario": usuarios
          }), 
          {
            headers: { 'Content-Type': 'application/json', 'Authorization': apiKeyGDO, "version-crm": version_crm },
            withCredentials: true
          }
        ).catch (function(err) 
        {
        setSuccessRegistro(false)  
        if (err.response) {
   
          setErrMsg(err.response.data.message);
        } else if (err.request) {
        
          setErrMsg('Ha ocurrido un error al registrar la ficha de postulación. Porfavor intente nuevamente');
        } else {
   
          setErrMsg('Ha ocurrido un error al registrar la ficha de postulación. Porfavor intente nuevamente');
        }
         });  
        const data = response?.data;
        setAprobarfichas(data) 
        setSuccessRegistro(true);
        setLoading(false);
  }
  

  async function ResincronizarFicha(){  
    setLoading(true);  
        const response = await axios.post(baseUrlGDO + 'api/oportunidades/' + guid_oportunidad + '/fichas_matricula/'+ PostobtenerFichaMatricula.idFichaMatricula + '/resincronizar' ,
          JSON.stringify({            
            "Usuario": usuarios,
            "GuidSubModalidad": dataCrm.guid_submodalidad_ingreso   
          }), 
          {
            headers: { 'Content-Type': 'application/json', 'Authorization': apiKeyGDO, "version-crm": version_crm },
            withCredentials: true
          }
        ).catch (function(err) 
        {
        setSuccessRegistro(false)  
        if (err.response) {
    
          setErrMsg(err.response.data.message);
        } else if (err.request) {
         
          setErrMsg('Ha ocurrido un error al resincronizar la ficha de postulación. Porfavor intente nuevamente');
        } else {
         
          setErrMsg('Ha ocurrido un error al resincronizar la ficha de postulación. Porfavor intente nuevamente');
        }
         });  
        const data = response?.data;
       
        setResincronizarData(data);
        setSuccessRegistro(true);
        setLoading(false);
  }
    
  const handleChange = (e) => {    
    switch (e.target.id) {
      case 'ApellidoPaterno':
        setApellidoPaterno(e.target.value);
        break;
      case 'ApellidoMaterno':
        setApellidoMaterno(e.target.value);
        break;
      case 'Nombres':
        setNombres(e.target.value);
        break;
      case 'NumeroDocumento':
        setNumeroDocumento(e.target.value);
        break;
      case 'FechaNacimiento':  
        setFechaNacimiento(e.target.value);               
        break;
      case 'ruc':
        setRucTrabNew(e.target.value);
        break;
      case 'TelefonoTrab':
        setTelefonoTrabNew(e.target.value);
        break;
      case 'AnexoTrab':
        setAnexoTrabNew(e.target.value);
        break;
      case 'TeléfonoCasa':
        setTelefonoCasaApoderado(e.target.value);
        break;
      default:
        break;
    }
  }
 
  function limpiartInputInformacionLaboral() {
    setRazonSocialTrabNew('')
    setRucTrabNew('')
    setTelefonoTrabNew('')
    setAnexoTrabNew('')
  }

  function loadRegistroObtener() 
  {
    const response =  obtenerFichaMatricula(guid_oportunidad)
    return response
  }
 
        useEffect(() => {
              loadRegistroObtener();
              setRefresh(true);

        },[guid_oportunidad]);

        useEffect(() => {
          function loadRegistro() 
          {
          const response =  obtenerRegistroFichaMatricula(guid_oportunidad)
          return response
          }
        loadRegistro()
      }, [guid_oportunidad]);
 
  useEffect(() => {
    setApellidoPaterno(PostobtenerFichaMatricula.apellidoPaterno);
    setApellidoMaterno(PostobtenerFichaMatricula.apellidoMaterno);
    setNombres(PostobtenerFichaMatricula.nombres);
    setNumeroDocumento(PostobtenerFichaMatricula.numeroDocumento);
    
    if(PostobtenerFichaMatricula.fechaNacimiento!=undefined)
    {
      setFechaNacimiento(moment(PostobtenerFichaMatricula.fechaNacimiento.split(" ")[0], "DD/MM/YYYY").format("YYYY-MM-DD"));
    }
 
  }, [PostobtenerFichaMatricula]);

  if (!PostobtenerFichaMatricula) return "No se encontró datos";

  const handleRadioButton = (event) => {
    const value = event.target.value;
    validator.current.purgeFields();
    setTipoTrabajoNew(value);

    if (value == 2) {
      setesobligatorioVal(false);
      limpiartInputInformacionLaboral()      
    } else if (value == 1) {
      setesobligatorioVal(true);      
    }
  };

  const handleLocationTrabajo = (guid_dep, nombre_dep, guid_prov, nombre_prov, guid_dist, nombre_dist) => {
    setDepartamentoTrabNew({ guid: guid_dep, nombre: nombre_dep });
    setProvinciaTrabNew({ guid: guid_prov, nombre: nombre_prov });
    setDistritoTrabNew({ guid: guid_dist, nombre: nombre_dist });
  }

  const handleLocationRelacion = (id, nombres) => {
    setRelacion({ id: id, nombre: nombres })
  }

  const handleDocApoderado = (codigo_doc, nombre_doc, numero_doc) => {
    setDocumentoApoderado({ codigo: codigo_doc, nombre: nombre_doc, numero: numero_doc });
  }

  const handleHorario = (codigo, nombre) => {
    setHorarios({ codigo:codigo, nombre:nombre});
  }

  const handleLocationPersonalApoderado = (guid_dep, nombre_dep, guid_prov, nombre_prov, guid_dist, nombre_dist) => {
    setDepApoderado({ guid: guid_dep, nombre: nombre_dep });
    setProvApoderado({ guid: guid_prov, nombre: nombre_prov });
    setDistApoderado({ guid: guid_dist, nombre: nombre_dist });
  }

  const handleCargaMatrizDocumento = (data) => {
    setCargaMatrizDocumento(data);    
  }
 
  const handleVistas = (id, nombre ,url,visible) => {  
    setvistaCargaDocumento({id:id, nombre:nombre ,url:url,visible:visible});    
  }
 

  const handleLocationPersonal = (guid_dep, nombre_dep, guid_prov, nombre_prov, guid_dist, nombre_dist) => {
    setDep({ guid: guid_dep, nombre: nombre_dep });
    setProv({ guid: guid_prov, nombre: nombre_prov });
    setDist({ guid: guid_dist, nombre: nombre_dist });
  }

   
  const handleDoc = (codigo_doc, nombre_doc, numero_doc) => {
    setDocumento({ codigo: codigo_doc, nombre: nombre_doc, numero: numero_doc });
  }

  const handleSex = ( id , nombres )=> {
    setSexo({ id:id , nombre:nombres })
  }  
   
  const retroceder = async (e) => {
    setNavegacionRetroceder(true);   
  }
 
  if (NavegacionRetroceder) {
    return <Navigate to={"/VerPdf?guid="+guid_oportunidad} />
  }

  const retrocederlogin = async (e) => {
    setNavegacionRetrocederlogin(true);   
  }

  if (NavegacionRetrocederlogin) {
    return <Navigate to="/" />
  }
 
     
  var mensaje=''
  if(anularficha.exito==true){
    mensaje='Ficha de postulación ha sido anulada. El flujo debe comenzar nuevamente con el ingreso de datos por parte del prospecto.'
  } else if(errorStatus==true){
    mensaje='No existe la ficha de postulación.'
  }
  else if(actualizarficha.exito==true){
    mensaje='Ficha de postulación ha sido actualizada.'
  }else if(Aprobarfichas.exito==true){
    mensaje='Ficha de postulación ha sido aprobada.'
  }
  else if(ResincronizarData.exito==true){
    mensaje='Ficha de postulación ha sido resincronizada.'
  }
  else if(PostobtenerFichaMatricula.length==0){
    mensaje='CARGANDO DATOS POR FAVOR ESPERE UN MOMENTO....'
  }else if(errMsg != ''){
    mensaje=errMsg
  }

  return (
 <> 
  {
    PostobtenerFichaMatricula.length==0 || anularficha.exito==true  || actualizarficha.exito==true || errMsg!='' || Aprobarfichas.exito==true || ResincronizarData.exito==true?
      (
       <div>
           <MensajeValidacion
             mensaje= {mensaje}
             >
           </MensajeValidacion>
       </div>
      )
      :
      ( 
        <div>
        <Helmet>
        <title>Ficha de Postulación</title>
        </Helmet>   
        {
           vistaCargaDocumento.visible == true ?
           (<UploaderDocument
           guid_oportunidad={guid_oportunidad}
           idTipoDoc={vistaCargaDocumento.id}
           tipoDoc={vistaCargaDocumento.nombre}
           versiones={vistaCargaDocumento.url}
           handleVistas={handleVistas}
           sololectura={true}  
           > 
           </UploaderDocument>) :('')
           }
      
        <div style={vistaCargaDocumento.visible==true?{'display':'none'}:{'display':'block'}  }>
        <Header> </Header>
         <Navbar bg="dark" expand="lg" fixed="top">
           <Navbar.Brand href="#">
             <img
               src="https://upn-repositorio-public.s3.amazonaws.com/logos/png/logo-upn-fondo-oscuro.png"
               width="160px"
               className="d-inline-block align-top"
             />
           </Navbar.Brand>
         </Navbar>
         <Container style={{ 'margin-top': '8rem' }}>
           <Titulo>
             FICHA DE POSTULACIÓN
           </Titulo>
           <Formulario action="">
             <Card style={{ borderRadius: '0px', margin: '1rem' }}>
               <Card.Body style={{ padding: '0px' }}>
                 <Card.Title style={{ background: '#6c757d', color: '#fff', padding: '1rem', fontSize: '18px' }}>DATOS GENERALES</Card.Title>
                 <Card.Text style={{ padding: '1rem' }}>
                   <Row>
                     <Col sm={4}>
                       <ComponenteInput
                         estilo="blocked"
                         tipo="text"
                         label="Sede"
                         placeholder={PostobtenerFichaMatricula.sede}
                         name="sede"
                         leyendaError="El usuario tiene que..."
                         expresionRegular=""
                       />
                     </Col>
                     <Col sm={4}>
                       <ComponenteInput
                         estilo="blocked"
                         tipo="text"
                         label="Periodo Académico"
                         placeholder={PostobtenerFichaMatricula.campania}
                         name="usuario"
                         leyendaError="El usuario tiene que..."
                         expresionRegular=""
                       />
                     </Col>
                     <Col sm={4}>
                       <ComponenteInput
                         estilo="blocked"
                         tipo="text"
                         label="Tipo de Admisión"
                         placeholder={PostobtenerFichaMatricula.modalidadIngreso}
                         name="usuario"
                         leyendaError="El usuario tiene que..."
                         expresionRegular=""
                       />
                     </Col>
                   </Row>
                   <Row>
                      <Col sm={4}>
                        <ComponenteInput
                          estilo="blocked"
                          tipo="text"
                          label="Carrera"
                          placeholder={PostobtenerFichaMatricula.carrera}
                          name="usuario"
                          leyendaError="El usuario tiene que..."
                          expresionRegular=""
                        />
                      </Col>
                      <Col sm={4}>
                        <ComponenteInput
                          estilo="blocked"
                          tipo="text"
                          label="Modalidad Estudio"
                          placeholder={PostobtenerFichaMatricula.modalidadEstudio == null ? "" : PostobtenerFichaMatricula.modalidadEstudio}
                          name="usuario"
                          leyendaError="El usuario tiene que..."
                          expresionRegular=""
                        />
                      </Col>
                     <Col sm={4}>
                       <ComponenteInput
                         estilo="blocked"
                         tipo="text"
                         label="Subtipo de Admisión"
                         placeholder={PostobtenerFichaMatricula.subModalidadIngreso}
                         name="usuario"
                         leyendaError="El usuario tiene que..."
                         expresionRegular=""
                       />
                     </Col>
                   </Row>
                 </Card.Text>
               </Card.Body>
             </Card>

             <Card style={{ borderRadius: '0px', margin: '1rem' }}>
               <Card.Body style={{ padding: '0px' }}>
                 <Card.Title style={{ background: '#6c757d', color: '#fff', padding: '1rem' }}>DATOS PERSONALES</Card.Title>
                 <Card.Text style={{ padding: '1rem' }}>
                   <Formulario action="">
                     <Row>
                       <Col sm={4}>
                         <ComponenteInput          
                           tipo="text"
                           label="Apellido Paterno"
                           name="ApellidoPaterno"
                           leyendaError="El usuario tiene que..."
                           value={ApellidoPaterno}
                           onChange={handleChange}
                         />
                       {esobligatorioVal ? validator.current.message('Apellido Paterno', ApellidoPaterno, 'required', { className: "text-danger" }) : ""}
                       </Col>
                       <Col sm={4}>
                         <ComponenteInput          
                           tipo="text"
                           label="Apellido Materno"    
                           name="ApellidoMaterno"
                           leyendaError="El usuario tiene que..."
                           value={ApellidoMaterno}
                           onChange={handleChange}
                         />

                       </Col>
                       <Col sm={4}>
                          <ComponenteInput  
                           tipo="text"
                           label="Nombres"
                           name="Nombres"
                           leyendaError="El usuario tiene que..."
                           value={Nombres}
                           onChange={handleChange}  
                          />
                          {esobligatorioVal ? validator.current.message('Nombres', Nombres, 'required', { className: "text-danger" }) : ""}
                       </Col>
                     </Row>
                     <Row>
                       <Col sm={4}> 
                         <SelectDocumento 
                           name="tipo_documento"
                           urlapi={baseUrlCRM + 'api/tipos_documento'}
                           seleccion=''
                           handleDoc={handleDoc}
                           validator={validator}
                           esobligatorio={true}
                           guidDocumento={PostobtenerFichaMatricula.codigoTipoDocumento == null ? "" : PostobtenerFichaMatricula.codigoTipoDocumento}
                           versionCRM={version_crm}
                         />

                            
                       </Col>
                       <Col sm={4}>
                         <ComponenteInput 
                           tipo="text"
                           label="Número de Documento"  
                           name="NumeroDocumento"
                           leyendaError="Debe ingresar un número de documento"
                           expresionRegular="/[0-9]{8}/"
                           value={NumeroDocumento}
                           onChange={handleChange}
                         />
                          {esobligatorioVal ? validator.current.message('Número de Documento', NumeroDocumento, 'required', { className: "text-danger" }) : ""}
                       </Col>
                       <Col sm={4}>
                         <ComponenteSelectSexo
                           label="Sexo"
                           name="Sexo"
                           validator={validator}
                           esobligatorio={true}
                           handleSex = {handleSex}         
                           guidSexo={PostobtenerFichaMatricula.codigoSexo == null? "" : PostobtenerFichaMatricula.codigoSexo }
                           
                         />
                       </Col>
                     </Row>
                      <Row>
                        <Col sm={4}>
                          <ComponenteInput 
                           tipo="date"
                           label="Fecha de nacimiento"
                           name="FechaNacimiento"
                           leyendaError="Fecha de nacimiento en rango no válido"
                           value={FechaNacimiento}
                           onChange={handleChange}
                           />
    
                           {validator.current.message('Fecha de nacimiento',FechaNacimiento && moment(FechaNacimiento, "YYYY-MM-DD"), 'required', { className: "text-danger" })}
                           <label>Edad: {getEdad(FechaNacimiento)} años</label>   
                       </Col> 
                     </Row>  
                     <Row>
                       <SelectUbicacion
                         estilo="blocked"
                         name="departamentos"
                         handleLocation={handleLocationPersonal}
                         validator={validator}
                         esobligatorio={true}
                         guid_dep={PostobtenerFichaMatricula.guidDepartamento == null ? "" : PostobtenerFichaMatricula.guidDepartamento}
                         guid_prov={PostobtenerFichaMatricula.guidProvincia == null ? "" : PostobtenerFichaMatricula.guidProvincia}
                         guid_dist={PostobtenerFichaMatricula.guidDistrito == null ? "" : PostobtenerFichaMatricula.guidDistrito}
                         versionCRM={version_crm}
                       />
                     </Row>
                     <Row>
                       <Col sm={12}>
                         <ComponenteInput
                           
                           tipo="text"
                           label="Dirección (Urb., Calle, Jr., Av.)"
                           placeholder=""
                           name="direccion"
                           leyendaError="El usuario tiene que..."
                           expresionRegular=""
                           estilo="blocked"
                           value={PostobtenerFichaMatricula.direccion}
                           onChange={handleChange}
                         />
                       </Col>
                     </Row>
                     <Row>
                       <Col sm={4}>
                         <ComponenteInput 
                           tipo="text"
                           label="Teléfono Casa"
                           placeholder="(00)0000000"
                           name="telefonoFijo"
                           leyendaError="El usuario tiene que..."
                           expresionRegular=""
                           estilo="blocked"
                           value={PostobtenerFichaMatricula.telefonoCasa}
                           onChange={handleChange}
                         />
                       </Col>
                       <Col sm={4}>
                         <ComponenteInput
                         
                           tipo="text"
                           label="Teléfono Celular"
                           placeholder=""
                           name="celular"
                           leyendaError="El usuario tiene que..."
                           expresionRegular=""
                           estilo="blocked"
                           value={PostobtenerFichaMatricula.telefonoCelular}
                           onChange={handleChange}
                         />   
                       </Col>

                       <Col sm={4}>
                         <ComponenteInput          
                           tipo="text"
                           label="E-mail"
                           placeholder=""
                           name="correoElectronico"
                           leyendaError="El usuario tiene que..."
                           expresionRegular=""
                           estilo="blocked"
                           value={PostobtenerFichaMatricula.email}
                           onChange={handleChange}
                         />
                        
                       </Col>
                     </Row>
                   </Formulario>
                 </Card.Text>
               </Card.Body>
             </Card>

              {
                  edadActual < 18 ? (
                      <Card style={{ borderRadius: '0px', margin: '1rem' }}>
                          <Card.Body style={{ padding: '0px' }}>
                          <Card.Title style={{ background: '#6c757d', color: '#fff', padding: '1rem' }}>DATOS DEL PADRE O APODERADO</Card.Title>
                          <Card.Text style={{ padding: '1rem' }}>
                              <Formulario action="">
                              <Row>

                                  <Col sm={4}>
                                  <ComponenteSelectRelacion
                                      estilo="blocked"
                                      name="Relacion"
                                      handleLocation={handleLocationRelacion}
                                      seleccion=''
                                      validator={validator}
                                      esobligatorio={true}
                                      guidRelacion={PostobtenerFichaMatricula.objApoderado.objRelacionApoderado.id}
                                  />
                                  </Col>

                                  <Col sm={4}>
                                  <ComponenteInput
                                  
                                      tipo="text"
                                      label="Ocupación"
                                      placeholder=""
                                      name="Ocupación"
                                      leyendaError="El usuario tiene que..."
                                      expresionRegular=""
                                      estilo="blocked"
                                      value={PostobtenerFichaMatricula.objApoderado.ocupacion} 
                                      onChange={handleChange}
                                  />
                                  </Col>
                              </Row>
                              <Row>
                                  <Col sm={4}>
                                  <ComponenteInput
                                      tipo="text"
                                      label="Apellido Paterno"
                                      placeholder=""
                                      name="ApellidoPaternoApoderado"
                                      leyendaError="Apellido Paterno..."
                                      expresionRegular=""
                                      estilo="blocked"
                                      value={PostobtenerFichaMatricula.objApoderado.apellidoPaterno}
                                      onChange={handleChange}
                                  />
                                  
                                  </Col>
                                  <Col sm={4}>
                                  <ComponenteInput
                                      tipo="text"
                                      label="Apellido Materno"
                                      placeholder=""
                                      name="ApellidoMaternoApoderado"
                                      leyendaError="El Apellido Materno..."
                                      expresionRegular=""
                                      estilo="blocked"
                                      value={PostobtenerFichaMatricula.objApoderado.apellidoMaterno}
                                      onChange={handleChange}
                                  />
                                  </Col>
                                  <Col sm={4}>
                                  <ComponenteInput
                                      tipo="text"
                                      label="Nombre Apoderado"
                                      placeholder=""
                                      name="NombresApoderado"
                                      leyendaError="Nombres"
                                      expresionRegular=""
                                      estilo="blocked"
                                      value={PostobtenerFichaMatricula.objApoderado.nombres} 
                                      onChange={handleChange}
                                  />
                                  
                                  </Col>
                              </Row>

                              <Row>
                                  <Col sm={4}>
                                  <SelectDocumento
                                      name="tipo_documento"
                                      urlapi={ baseUrlCRM + "api/tipos_documento"}
                                      seleccion=''
                                      handleDoc={handleDocApoderado}
                                      validator={validator}
                                      esobligatorio={true}
                                      guidDocumento={PostobtenerFichaMatricula.objApoderado.codigoTipoDocumento}     
                                      versionCRM={version_crm}  
                                      estilo="blocked"                            
                                  />
                                  </Col>
                                  <Col sm={4}>
                                  <ComponenteInput
                                      tipo="text"
                                      label="Número de Documento"
                                      placeholder=""
                                      name="NúmeroDocumento"
                                      leyendaError="El usuario tiene que..."
                                      expresionRegular="/[0-9]{8}/"
                                      value={PostobtenerFichaMatricula.objApoderado.numeroDocumento} 
                                      onChange={handleChange}
                                      estilo="blocked"
                                  />                                 
                                  </Col>
                              </Row>

                              <Row>
                                  <SelectUbicacion
                                  name="departamentos"
                                  handleLocation={handleLocationPersonalApoderado}
                                  validator={validator}
                                  esobligatorio={true}
                                  guid_dep={PostobtenerFichaMatricula.objApoderado.guidDepartamento == null ? "" : PostobtenerFichaMatricula.objApoderado.guidDepartamento}
                                  guid_prov={PostobtenerFichaMatricula.objApoderado.guidProvincia== null ? "" : PostobtenerFichaMatricula.objApoderado.guidProvincia}
                                  guid_dist={PostobtenerFichaMatricula.objApoderado.guidDistrito== null ? "" : PostobtenerFichaMatricula.objApoderado.guidDistrito}
                                  versionCRM={version_crm}
                                  estilo="blocked"
                                  />
                              </Row>

                              <Row>
                                  <Col sm={4}>
                                  <ComponenteInput
                                      tipo="text"
                                      label="Dirección (Urb., Calle, Jr, Av.)"
                                      placeholder=""
                                      name="DirecciónApoderado"
                                      leyendaError="El usuario tiene que..."
                                      expresionRegular=""
                                      estilo="blocked"
                                      value={PostobtenerFichaMatricula.objApoderado.direccion}
                                      onChange={handleChange}
                                  />
                                  </Col>
                              </Row>


                              <Row>
                                  <Col sm={4}>
                                  <ComponenteInput
                                      tipo="text"
                                      label="Teléfono Casa"
                                      placeholder="(00)0000000"
                                      name="TeléfonoCasa"
                                      leyendaError="El usuario tiene que..."
                                      expresionRegular=""
                                      estilo="blocked"
                                      value={PostobtenerFichaMatricula.objApoderado.telefonoCasa} 
                                      onChange={handleChange}
                                  />
                                  </Col>

                                  <Col sm={4}>
                                  <ComponenteInput
                                      tipo="text"
                                      label="Teléfono Celular"
                                      placeholder=""
                                      name="celularApoderado"
                                      leyendaError="El usuario tiene que..."
                                      expresionRegular=""
                                      estilo="blocked"
                                      value={PostobtenerFichaMatricula.objApoderado.telefonoCelular}
                                      onChange={handleChange}
                                  />
                                  

                                  </Col>

                                  <Col sm={4}>
                                  <ComponenteInput
                                      tipo="text"
                                      label="E-mail"
                                      placeholder=""
                                      name="mailApoderado"
                                      leyendaError="El usuario tiene que..."
                                      expresionRegular=""
                                      estilo="blocked"
                                      value={PostobtenerFichaMatricula.objApoderado.email} 
                                      onChange={handleChange}
                                  />
                                  

                                  </Col>
                              </Row>
                              </Formulario>
                          </Card.Text>
                          </Card.Body>
                      </Card>
                  ) : (<div></div>)
              }

              {
                  valorTipoFicha != 1  ? (
                      <Card style={{ borderRadius: '0px', margin: '1rem' }}>
                          <Card.Body style={{ padding: '0px' }}>
                          <Card.Title style={{ background: '#6c757d', color: '#fff', padding: '1rem' }}>INFORMACIÓN DEL CENTRO LABORAL</Card.Title>
                          <Card.Text style={{ padding: '1rem' }}>
                              <Formulario action="">
                              <Row>
                                  <Col sm={12}>
                                  <text>Trabajo prestado en forma</text>
                                  <Wrapper>
                                      <Col sm={6}>
                                      <Item>
                                          <RadioButton
                                          type="radio"
                                          name="radio"
                                          // value="1"
                                          // checked={tipoTrabajo === "1"} esTrabajadorDependiente PostobtenerFichaMatricula.esTrabajadorDependiente
                                          checked={(PostobtenerFichaMatricula.inscripcion.esTrabajadorDependiente == true) ? (true) : (false) }
                                          onChange={(event) => handleRadioButton(event)}
                                          />
                                          <RadioButtonLabel />
                                          <div>Dependiente</div>
                                      </Item>
                                      </Col>
                                      <Col sm={6}>
                                      <Item>
                                          <RadioButton
                                          type="radio"
                                          name="radio"
                                          // value="2"
                                          checked={(PostobtenerFichaMatricula.inscripcion.esTrabajadorDependiente == false) ? (true):(false) }
                                          onChange={(event) => handleRadioButton(event)}
                                          />
                                          <RadioButtonLabel />
                                          <div>Independiente</div>
                                      </Item>
                                      </Col>
                                  </Wrapper>
                                  </Col>
                              </Row>
                              <Row>
                                  <Col sm={8}>
                                  <ComponenteInput
                                      tipo="text"
                                      label="Razón Social"
                                      placeholder=""
                                      name="razonSocial"
                                      leyendaError="El usuario tiene que..."
                                      expresionRegular=""
                                      estilo={"blocked"}
                                      value={PostobtenerFichaMatricula.inscripcion.razonSocial} 
                                      onChange={handleChange}
                                  />
                                  
                                  </Col>
                                  <Col sm={4}>
                                  <ComponenteInput
                                      tipo="text"
                                      label="RUC"
                                      placeholder=""
                                      name="ruc"
                                      leyendaError="El usuario tiene que..."
                                      expresionRegular=""
                                      estilo={"blocked"}
                                      value={PostobtenerFichaMatricula.inscripcion.ruc} 
                                      onChange={handleChange}
                                  />
                                  </Col>
                              </Row>
                              <Row>
                                  <Col sm={12}>
                                  <SelectUbicacion
                                      name="departamentos"
                                      handleLocation={handleLocationTrabajo}
                                      estilo={"blocked"}
                                      validator={validator}
                                      esobligatorio={tipoTrabajo == "1" ? true : false}
                                      guid_dep={PostobtenerFichaMatricula.inscripcion.guidDepartamentoTrabajo}
                                      guid_prov={PostobtenerFichaMatricula.inscripcion.guidProvinciaTrabajo}
                                      guid_dist={PostobtenerFichaMatricula.inscripcion.guidDistritoTrabajo}
                                      versionCRM={version_crm}
                                  />
                                  </Col>
                              </Row>
                              <Row>
                                  <Col sm={6}>
                                  <ComponenteInput
                                      tipo="text"
                                      label="Teléfono"
                                      placeholder=""
                                      name="TelefonoTrab"
                                      leyendaError="El usuario tiene que..."
                                      expresionRegular=""
                                      estilo={"blocked"}
                                      value={PostobtenerFichaMatricula.inscripcion.telefono} 
                                      onChange={handleChange}
                                  />
                                  
                                  </Col>
                                  <Col sm={6}>
                                  <ComponenteInput
                                      tipo="text"
                                      label="Anexo"
                                      placeholder=""
                                      name="AnexoTrab"
                                      leyendaError="El usuario tiene que..."
                                      expresionRegular=""
                                      estilo={"blocked"}
                                      value={PostobtenerFichaMatricula.inscripcion.anexo}
                                      onChange={handleChange}
                                  />
                                  </Col>
                              </Row>
                              </Formulario>
                          </Card.Text>
                          </Card.Body>
                      </Card>
                  ) : (<div></div>)
              }

              {
                  valorTipoFicha == 2 ||  valorTipoFicha == 4 ||  valorTipoFicha == 5 ? (
                  <Card style={{ borderRadius: '0px', margin: '1rem' }}>
                      <Card.Body style={{ padding: '0px' }}>
                        <Card.Title style={{ background: '#6c757d', color: '#fff', padding: '1rem' }}>HORARIOS</Card.Title>
                        <Card.Text style={{ padding: '1rem' }}>
                          <Formulario action="">
                            <Row>
                              <Col sm={12}>
                              <SelectHorario    
                                  name="nombre_horario"
                                  urlapi={baseUrlCRM + "api/horarios"}                                     
                                  handleHorario={handleHorario}
                                  validator={validator}
                                  esobligatorio={true}
                                  guidHorario={PostobtenerFichaMatricula.inscripcion.guidHorario}
                                  versionCRM={version_crm}  
                                  estilo="blocked" 
                                />
                              </Col>

                            </Row>
                          </Formulario>
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  ) : (<div></div>)
              }
              
              {
                      vistaCargaDocumento.visible==false?
                      <Card style={{ borderRadius: '0px', margin: '1rem' }}>
                      <Card.Body style={{ padding: '0px' }}>
                        <Card.Title style={{ background: '#6c757d', color: '#fff', padding: '1rem' }}>DOCUMENTOS PARA MATRÍCULA</Card.Title>
                        <Card.Text style={{ padding: '1rem' }}>              
                          {loading == false && PostobtenerFichaMatricula.guidSubModalidadIngreso != undefined?    
                          <Documentos
                            guid_oportunidad={guid_oportunidad}
                            validator={validator}   
                            guid_sub_modalidad_ingreso={PostobtenerFichaMatricula.guidSubModalidadIngreso}
                            handleVistas={handleVistas}    
                            handleCargaMatrizDocumento={handleCargaMatrizDocumento}    
                            beneficiosEconomicos={PostobtenerFichaMatricula.subModalidadTieneBeneficioEconomico}    
                            sololectura={true}
                          />:('') }
                        </Card.Text>
                      </Card.Body>
                      </Card>:""     
              }   

             <Card style={{ borderRadius: '0px', margin: '1rem' }}>
              <Card.Body style={{ padding: '0px' }}>
                <Card.Title style={{ background: '#6c757d', color: '#fff', padding: '1rem' }}>DECLARACIONES / COMPROMISOS</Card.Title>
                <Card.Text style={{ padding: '1rem' }}>
                  Declaro / me comprometo en lo siguiente:
                  <br /><br />
                  {
                        datosDeclaracion?.map((files, index) => {
                          return (
                            files.id != null && files.id > 0 ?
                              (
                                <div className="card-block card-cuerpo">
                                  <div className="row check-contenedor">
                                    <div className="col-sm-12 custom-control custom-checkbox">
                                      <input type="checkbox" id={'chkDeclaracion_' + files.id} name={'chkDeclaracion_' + files.id}
                                        value={files.id}
                                        onChange={(event) => handleDeclaracion(event)}
                                      />
                                    </div>
                                  </div>
                                </div>
                              ) : 
                              (<div className="card-block card-cuerpo"></div>)
                          )
                        })
                  }
                  <ContenedorTerminos>
                  {
                   PostobtenerFichaMatricula.lstDeclaracionJurada.map((files, index) => {
                   return (        
                    <div className="row  ">
                          <div className="col-sm-12 custom-control ">
                                                  <Check
                                                    type='checkbox'
                                                    checked={true}
                                                    inline
                                                    style={{color: 'black' }}
                                                  />
                          <label  style={{color: 'black' }} className="custom-control-label d-inline"   >
                            {files.descripcion}
                          </label>
                      </div>
                    </div>
               )
             })
           } 
                </ContenedorTerminos>
                    {
                      false && <MensajeError>
                      {/*<p>*/}
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                        <b>Error:</b> Por favor rellena el formulario correctamente.
                      {/*/p>*/}
                      </MensajeError>
                    }       
                </Card.Text>
              </Card.Body>
              </Card>
                <Card style={{ borderRadius: '0px', margin: '1rem' }}>
                <Card.Body style={{ padding: '0px' }}>
                  <Card.Title style={{ background: '#6c757d', color: '#fff', padding: '1rem' }}>INFORMACIÓN DE DISCAPACIDAD</Card.Title>
                  {
                    respuestasCuestionario != "" ? 
                    <Card.Text style={{ padding: '1rem' }}>
                      {respuestasCuestionario.map((respuesta,i) => {
                        if(respuesta.idPregunta == "12" || respuesta.idPregunta == "13" || respuesta.idPregunta == "14" || respuesta.idPregunta == "15"){
                        return (
                          <>
                                {respuesta.descripcionPregunta}: 
                                <label>
                                &nbsp;
                                  <b>
                                  {respuesta.opciones[0].descripcionOpcion}
                                  </b>
                                </label>
                                <br />
                                <em>
                                <div dangerouslySetInnerHTML={{ __html: respuesta.aclaracion }} />
                                </em>
                                <br />
                          </>
                        )}
                      })
                      }
                    </Card.Text>
                  :(<></>)}
                </Card.Body>
              </Card>
                 <Card style={{ borderRadius: '10px', margin: '1rem' }}>
                   <Card.Body style={{ padding: '40px' }}>
                         <div className="form-group">
                            <div className="card">
                               <div className="card-block card-cuerpo">         
                                   <div className="row">
                                              <div className="col-sm-6" style={{ textAlign: 'left' }}>
                                                      <button type="button" value="Previsualizar" 
                                                      id="lnkGenerarPdfFicha" 
                                                      className="btn btn-lg btn-primary btn-warning" 
                                                      title="Previsualizar PDF Generado"
                                                      onClick={retroceder}
                                                      >
                                                      Previsualizar PDF
                                                      </button>
                                                      {
                                                            <button type="button" value="Anular" className="btn btn-lg btn-danger" 
                                                            title="Anular Ficha" data-toggle="modal" data-target="#mAnularFicha"
                                                            disabled={PostobtenerFichaMatricula.aprobada}
                                                            onClick={handleSubmit}
                                                            >
                                                              Anular
                                                            </button> 
                                                      }        
                                              </div> 

                                                <div className="col-sm-6" style={{ textAlign: 'right' }}>
                                                      <button type="button" value="Actualizar" className="btn btn-lg btn-primary btn-warning" 
                                                        id="btnActualizarFicha" title="Actualizar datos de Ficha"
                                                        disabled={PostobtenerFichaMatricula.aprobada}
                                                        onClick={ActualizarFicha}
                                                        >
                                                        Actualizar
                                                      </button>
                                                      <button type="button" value="Aprobar" className="btn btn-lg btn-primary btn-success" 
                                                       id="btnAprobarFicha" title="Aprobación de Ficha" data-toggle="modal"
                                                       disabled={PostobtenerFichaMatricula.aprobada}
                                                       onClick={handleSubmitAprobar}>
                                                        Aprobar
                                                    </button>
                                                </div>
                                            </div>

                        {
                            ( 
                            (PostobtenerFichaMatricula.guidModalidadIngreso != dataCrm.guid_modalidad_ingreso || 
                            PostobtenerFichaMatricula.guidSubModalidadIngreso != dataCrm.guid_submodalidad_ingreso)
                            && PostobtenerFichaMatricula.aprobada == true &&  dataCrm.filename_ubicacion == "Admisión" &&
                            PostobtenerFichaMatricula.ultimoGuidSubmodalidadResincronizado != dataCrm.guid_submodalidad_ingreso 
                            )
                            ?
                            ( 
                                 <div className="row">
                                    <div className="col-sm-6"  style={{ textAlign: 'left' }}>  
                                     <button  type="button" value="Cerrar Sesión" className="btn btn-lg btn-secondary" 
                                        id="btnCerrarSesión" data-toggle="modal"
                                        onClick={retrocederlogin}
                                        >
                                        Cerrar Sesión
                                     </button>
                                    </div>     

                                  <div className="col-sm-6"  style={{ textAlign: 'right' }}>  
                                      <button type="button" value="Resincronizar ficha" 
                                      className="btn btn-lg btn-primary" id="btnResincronizar"
                                      
                                      onClick={handleSubmitResincronizar}>
                                      Resincronizar ficha
                                      </button>
                                 </div>            
                              </div>
                           )
                           :
                            ( 
                               <div className="row">
                               <div className="col-sm-6"  style={{ textAlign: 'left' }}>  
                                <button  type="button" value="Cerrar Sesión" className="btn btn-lg btn-secondary" 
                                 id="btnCerrarSesión"
                                 onClick={retrocederlogin}
                                 >
                                 Cerrar Sesión
                                </button>
                               </div>      
                               </div>
                           )
                        }            
                               </div>
                          </div>
                      </div>  
                  </Card.Body>
                 </Card>
              
              <Modal show={showModal} onHide={handleClose}>
                <Modal.Header >
                  <Modal.Title>¿Estás seguro que deseas anular la Ficha actual?</Modal.Title>
                </Modal.Header>
                <Modal.Body>Esta acción eliminará los datos ingresados por el prospecto, el prospecto deberá hacer nuevamente la modificación de la información que cargará a partir de la data de CRM.</Modal.Body>
                <Modal.Footer>
                    <BotonGrisModal type="submit" onClick={handleClose}> Cancelar</BotonGrisModal>
                    <BotonAmarilloModal
                                //  disabled={activarBoton}
                                onClick={AnularFicha}
                                //  style={activarBoton == true ? { backgroundColor: '#ccc' } : { backgroundColor: '#ffc107' }}
                                >Aceptar
                    </BotonAmarilloModal>
                </Modal.Footer>
              </Modal>

              <Modal show={showModalAprobar} onHide={handleCloseAprobar}>
                <Modal.Header >
                  <Modal.Title>¿Estás seguro que deseas aprobar la Ficha actual?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                        Esta acción enviará los datos ingresados de la ficha a la plataforma de gestión documental (GDO) como pendiente de revisión y ya no podrá ser modificada a menos que sea rechazada ahí.
                        Asimismo se enviará la carta de compromiso/cargo entrega de documentos al correo personal del postulante.
                        Asegurar que la data es la misma que en banner y crm.
                </Modal.Body>
                <Modal.Footer>
                    <BotonGrisModal type="submit" onClick={handleCloseAprobar}> Cancelar</BotonGrisModal>
                    <BotonAmarilloModal
                                //  disabled={activarBoton}
                                onClick={AprobarFicha}
                                //  style={activarBoton == true ? { backgroundColor: '#ccc' } : { backgroundColor: '#ffc107' }}
                                >Aceptar
                    </BotonAmarilloModal>
                </Modal.Footer>
              </Modal>


              <Modal show={showModalResincronizar} onHide={handleCloseResincronizar}>
                <Modal.Header >
                  <Modal.Title>¿Estás seguro que deseas Resincronizar la Ficha actual?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                   Se ha detectado un cambio en la modalidad / submodalidad de la ficha con respecto a la 
                   registrada en CRM, si resincroniza la ficha esta viajara junto con todos los documentos
                   que coincidan con respecto a la nueva matriz.
                </Modal.Body>
                <Modal.Footer>
                    <BotonGrisModal type="submit" onClick={handleCloseResincronizar}> Cancelar</BotonGrisModal>
                    <BotonAmarilloModal       
                                onClick={ResincronizarFicha}  
                                >Aceptar
                    </BotonAmarilloModal>
                </Modal.Footer>
              </Modal>

           </Formulario>
           <Footer><p>© 2022 Universidad Privada del Norte</p></Footer>
         </Container>
       </div>        
      
     <ProgressIntoDialog open={loading} />
        </div>
       )

  }
   
 
        
 </>
  );
}
export default FichaMatricula;